// extracted by mini-css-extract-plugin
export default {"w-context-menu":"---------packages-corgi-x-src-components-VideoSection-useWistiaPlayer-wistia-overrides__w-context-menu"};